import { Transition } from "@uirouter/angularjs";
import { IComponentOptions } from "angular";
import { LazyCompilerService, LAZY_COMPILER_SERVICE } from "./lazy-compiler.service";

export function registerComponentFromTransition(transition: Transition, name: string, options: IComponentOptions) {
    const lazyCompilerService = transition.injector().get<LazyCompilerService>(LAZY_COMPILER_SERVICE);
    if (lazyCompilerService == null) {
        throw new Error("Unable to get lazy compiler");
    }

    lazyCompilerService.registerComponent(name, options);
}


// WEBPACK FOOTER //
// ./app/core/lazy-route.helper.ts